import siteConfig from "site-config";
import { ILookup, ILookupRowItem, IValueTypeMap } from "./types";
import { buildStatementFromLookupPlan } from "./statement-builder";
import { transformLookupResponse } from "./transform-results";
import { getStore } from "store";

interface IExecuteLookupOptions {
    merchantId: string;
    offset?: number;
    limit?: number;
}

/**
 * Make executesql request based on lookup plan and specified values
 * TODO: Add unit test
 * @param lookupPlan lookup plan to fetch by
 * @param dependenciesValues values of WHERE conditions, key-ed by schema field name
 * @param options
 * @returns
 */
export const executeLookup = (
    lookupPlan: ILookup,
    dependenciesValues: IValueTypeMap,
    options: IExecuteLookupOptions
): Promise<ILookupRowItem[]> => {
    const statement = buildStatementFromLookupPlan(lookupPlan, dependenciesValues, options.offset, options.limit);
    const requestBody = {
        merchant_id: options.merchantId,
        database_name: lookupPlan.from.database_name,
        table_name: lookupPlan.from.table_name,
        statement,
    };
    const { scope } = getStore().getState();
    return fetch(`${siteConfig.goAPI}/v1/merchanttable/executesql`, {
        method: "POST",
        credentials: "include",
        headers: {
            "x-requested-with": "XMLHttpRequest",
            "Active-Brand": scope?.brand?._id ?? "",
            module: "default",
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
    })
        .then((response) => {
            if (response.ok) {
                return response.json();
            }
        })
        .then((results) => {
            return transformLookupResponse(results, lookupPlan.select);
        });
};
